import React from "react";
import XIcon from "@streeteasy/design-system/deprecated/Icons/SVG/XIcon";
import {
  array,
  bool,
  element,
  func,
  number,
  oneOfType,
  string
} from "prop-types";

import { POSITION, THEME } from "./constants";
import {
  CloseButton,
  CloseButtonScreenReaderText,
  TooltipContentWrapper,
  TooltipTriangle
} from "./styled";

const TooltipContent = props => (
  <TooltipContentWrapper
    ref={props.tooltipElem}
    id="tooltip-content"
    position={props.position}
    role="tooltip"
    theme={props.theme}
    width={props.width}
    zIndex={props.zIndex}
  >
    {props.hasCloseButton && (
      <CloseButton onClick={props.onClickClose}>
        <CloseButtonScreenReaderText>
          click to close
        </CloseButtonScreenReaderText>
        <XIcon color={props.closeButtonColor} />
      </CloseButton>
    )}
    <TooltipTriangle position={props.position} theme={props.theme} />
    {props.children}
  </TooltipContentWrapper>
);

TooltipContent.propTypes = {
  children: oneOfType([string, element, array]),
  hasCloseButton: bool,
  closeButtonColor: string,
  onClickClose: func,
  position: string,
  theme: string,
  tooltipElem: func,
  width: string,
  zIndex: number.isRequired
};

TooltipContent.defaultProps = {
  children: null,
  hasCloseButton: false,
  closeButtonColor: undefined,
  onClickClose: () => {},
  position: POSITION.RIGHT,
  theme: THEME.LARGE,
  tooltipElem: () => {},
  width: ""
};

export default TooltipContent;
